<template>
    <div class="move-view" ref="moveView"
         @mousedown="downRP"
         @touchstart="downRP"
         @mousemove="moveRP"
         @touchmove="moveRP"
         @mouseleave="moveRP"
         @mouseover="endRP"
         @mouseup="endRP"
         @touchend="endRP">

        <slot></slot>


    </div>
</template>

<script>


export default {
    name: 'MovableView.vue',
    components: {},
    data() {
        return {
            rpMoving: false,
            originRPX: 0,
            originRPY: 0,
            currPointX: 0,
            currPointY: 0,
        };
    },
    mounted() {

    },
    methods: {
        m(event) {
            /*console.log(event)
            let target = event.target;

            target.style.pointerEvents = 'none';
            setTimeout(() => {
                let dom = document.elementFromPoint(event.clientX, event.clientY);
                console.log('开始点击: ', dom, event.clientX, event.clientY)
                dom.click();
                console.log('点击结束')
                setTimeout(() => {
                    target.style.pointerEvents = 'auto';
                }, 100);
            }, 80);*/
        },
        downRP(event) {
            this.rpMoving = true;
            let touch;
            if (event.touches) {
                touch = event.touches[0];
            } else {
                touch = event;
            }

            //this.originRPX = event.target.offsetLeft;
            //this.originRPY = event.target.offsetTop;

            this.originRPX = this.$refs.moveView.offsetLeft;
            this.originRPY = this.$refs.moveView.offsetTop;

            this.currPointX = touch.clientX;
            this.currPointY = touch.clientY;
        },
        moveRP(event) {
            if (!this.rpMoving) {
                return;
            }
            let touch;
            if (event.touches) {
                touch = event.touches[0];
            } else {
                touch = event;
            }

            //let target = event.target;
            let target = this.$refs.moveView;

            let offsetX = touch.clientX - this.currPointX;
            let offsetY = touch.clientY - this.currPointY;

            target.style.left = this.originRPX + offsetX + "px";
            target.style.top = this.originRPY + offsetY + "px";
            target.style.right = "auto";

            //阻止页面的滑动默认事件；如果碰到滑动问题，1.2 请注意是否获取到 touchmove
            /*document.addEventListener("touchmove", function () {
                event.preventDefault();
            }, false);*/
        },
        endRP(event) {
            this.rpMoving = false;

            let target = this.$refs.moveView;
            this.$emit('moveEnd', target);

        },
    }
};
</script>

<style scoped>
    .move-view {

    }
</style>